// Legacy, non-standard browser APIs used for download fallbacks. They are not
// part of the standard DOM lib types, so we describe them locally.
type LegacyNavigator = Navigator & {
  msSaveBlob?: (blob: Blob, defaultName?: string) => boolean;
};

type LegacyWindow = Window & {
  webkitURL?: typeof URL;
};

export const downloadText = (filename: string, text: string): void => {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const fileDownload = (data: BlobPart, filename: string, mime?: string, bom?: BlobPart): void => {
  const blobData: BlobPart[] = typeof bom !== 'undefined' ? [bom, data] : [data];
  const blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  const legacyNavigator = window.navigator as LegacyNavigator;
  if (typeof legacyNavigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    legacyNavigator.msSaveBlob(blob, filename);
  } else {
    const legacyWindow = window as LegacyWindow;
    const urlApi: typeof URL = window.URL ? window.URL : (legacyWindow.webkitURL as typeof URL);
    const blobURL = urlApi.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 0);
  }
};
